"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

var _styles = require("@material-ui/core/styles");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = function styles(theme) {
  return {
    paper: {
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme.shadows[5],
      padding: theme.spacing.unit * 4,
      margin: 'auto'
    },
    title: {
      marginBottom: theme.spacing.unit
    },
    buttonContainer: {
      marginTop: theme.spacing.unit,
      position: 'relative',
      float: 'right'
    }
  };
};

var DialogButton = /*#__PURE__*/function (_Component) {
  _inherits(DialogButton, _Component);

  var _super = _createSuper(DialogButton);

  function DialogButton() {
    var _this;

    _classCallCheck(this, DialogButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isDialogOpen: false
    });

    _defineProperty(_assertThisInitialized(_this), "openDialog", function () {
      return _this.setState({
        isDialogOpen: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "confirm", function (e) {
      var onClick = _this.props.onClick;
      onClick();

      _this.closeDialog(e);
    });

    _defineProperty(_assertThisInitialized(_this), "closeDialog", function (e) {
      e.stopPropagation();

      _this.setState({
        isDialogOpen: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onClick", function () {
      var _this$props = _this.props,
          dialogType = _this$props.dialogType,
          onClick = _this$props.onClick;

      if (dialogType === 'alert') {
        Promise.resolve(onClick()).then(_this.openDialog);
        return;
      }

      if (dialogType === 'confirmation') {
        _this.openDialog();

        return;
      }

      onClick();
    });

    return _this;
  }

  _createClass(DialogButton, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          buttonClasses = _this$props2.buttonClasses,
          children = _this$props2.children,
          classes = _this$props2.classes,
          dialogBody = _this$props2.dialogBody,
          _this$props2$dialogCa = _this$props2.dialogCancelButton,
          dialogCancelButton = _this$props2$dialogCa === void 0 ? 'Cancel' : _this$props2$dialogCa,
          _this$props2$dialogCo = _this$props2.dialogConfirmButton,
          dialogConfirmButton = _this$props2$dialogCo === void 0 ? 'OK' : _this$props2$dialogCo,
          dialogTitle = _this$props2.dialogTitle,
          dialogType = _this$props2.dialogType,
          _this$props2$dialogWi = _this$props2.dialogWidth,
          dialogWidth = _this$props2$dialogWi === void 0 ? 500 : _this$props2$dialogWi;
      var isDialogOpen = this.state.isDialogOpen;

      var innerProps = _objectSpread({}, this.props);

      delete innerProps.dialogBody;
      delete innerProps.dialogCancelButton;
      delete innerProps.dialogConfirmButton;
      delete innerProps.dialogTitle;
      delete innerProps.dialogType;
      delete innerProps.dialogWidth;
      delete innerProps.buttonClasses;
      innerProps.classes = buttonClasses;
      var title = dialogTitle || (dialogType === 'alert' ? 'Attention' : 'Please Confirm');
      var body = typeof dialogBody === 'string' ? /*#__PURE__*/_react.default.createElement(_core.Typography, null, dialogBody) : dialogBody;
      var confirmAction = dialogType === 'alert' ? this.closeDialog : this.confirm;
      var confirmButton = typeof dialogConfirmButton === 'string' ? /*#__PURE__*/_react.default.createElement(_core.Button, {
        color: "primary",
        variant: "contained",
        onClick: confirmAction,
        className: classes.confirmButton,
        "data-test-id": "DialogButton-confirm"
      }, dialogConfirmButton) : /*#__PURE__*/(0, _react.cloneElement)(dialogConfirmButton, {
        onClick: confirmAction
      });
      var cancelButton = typeof dialogCancelButton === 'string' ? /*#__PURE__*/_react.default.createElement(_core.Button, {
        onClick: this.closeDialog,
        color: "secondary",
        variant: "contained"
      }, dialogCancelButton) : /*#__PURE__*/(0, _react.cloneElement)(dialogCancelButton, {
        onClick: this.closeDialog
      });
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Button, _extends({}, innerProps, {
        onClick: this.onClick
      }), children), /*#__PURE__*/_react.default.createElement(_core.Dialog, {
        open: isDialogOpen,
        onClose: this.closeDialog,
        "data-test-id": "DialogButton-dialog"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: classes.paper,
        style: {
          width: dialogWidth
        }
      }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
        variant: "h6",
        className: classes.title
      }, title), body, /*#__PURE__*/_react.default.createElement("div", {
        className: classes.buttonContainer
      }, confirmButton, dialogType === 'confirmation' && cancelButton))));
    }
  }]);

  return DialogButton;
}(_react.Component);

var _default = (0, _styles.withStyles)(styles)(DialogButton);

exports.default = _default;